import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import { Link, Typography } from '@mui/material';
import { Trans } from 'react-i18next';

import { t } from '../../../../../../utils/i18next';
import { storeContext } from '../../../../../context';

const StyledContainer = styled.div`
  a.link {
    > * {
      pointer-events: none;
    }
  }
`;

const FinancialAssistance = observer(({ children }) => {
  const {
    translations: { currentLanguage },
    providerLinks: { providerMessageLink }
  } = useContext(storeContext);

  return (
    <>
      {providerMessageLink && (
        <>
          <StyledContainer>
            <Typography variant={'subtitle2'} gutterBottom>
              {t('payables.total_side_bar_message.headline')}
            </Typography>
            <Typography gutterBottom>
              {t('payables.total_side_bar_message.content', {
                interpolation: { escapeValue: false }
              })}
            </Typography>
            <Trans
              i18nKey={'payables.total_side_bar_message.cta'}
              components={[
                <Link
                  key={0}
                  id={'financial-assistance'}
                  href={providerMessageLink}
                  rel="noopener noreferrer"
                  target="_blank"
                  color={'secondary'}
                  component="a"
                  variant={'body2'}
                  className={'link'}
                >
                  placeholder
                </Link>
              ]}
            />
          </StyledContainer>
          {children}
        </>
      )}
    </>
  );
});

export default FinancialAssistance;
